export const base_url ="https://api.savannahshinehub.com/api/"
